module.exports = Object.assign(function GamepadButton() {}, {
  FACE_1: 0,
  FACE_2: 1,
  FACE_3: 2,
  FACE_4: 3,
  L_SHOULDER_1: 4,
  R_SHOULDER_1: 5,
  L_SHOULDER_2: 6,
  R_SHOULDER_2: 7,
  SELECT: 8,
  START: 9,
  DPAD_UP: 12,
  DPAD_DOWN: 13,
  DPAD_LEFT: 14,
  DPAD_RIGHT: 15,
  VENDOR: 16
});